module.exports = __webpack_public_path__ + "img/arrow-bottom.e1350120.svg";